// Чистые функции выбора просмотрщика (MYUA-17117). Только `import type`: runtime-импорт model.ts
// тянет urls.ts → api.ts → @myua/api, и node-тесты (vitest) перестали бы собираться.
import type { ExtensionDefinition, MediaType } from './model';

/** Основной просмотрщик расширения и альтернативные, в порядке показа в переключателе. */
export const getViewerOptions = (d: ExtensionDefinition): MediaType[] => [
  d.mt,
  ...(d.alternativeViewers ?? []),
];

/** Сохранённый выбор, если он допустим для расширения, иначе основной просмотрщик. */
export const sanitizeViewer = (d: ExtensionDefinition, chosen: MediaType | null): MediaType =>
  chosen !== null && getViewerOptions(d).includes(chosen) ? chosen : d.mt;

export const applyViewerChoice = (
  d: ExtensionDefinition,
  chosen: MediaType | null,
): ExtensionDefinition => ({ ...d, mt: sanitizeViewer(d, chosen) });
